/**
 * Reč u pravom obliku uz brojku.
 *
 * ZAŠTO POSTOJI
 *   U sažetku poslovođinog ekrana je stajalo `n === 1 ? 'adresa' : 'adresa'` —
 *   obe grane iste — pa je ekran pisao „2 adresa za ispravku". Na tri mesta je
 *   bio isti obrazac i ista greška, jer se pisao svaki put ponovo.
 *
 * PRAVILO
 *   Oblik ide po ZADNJOJ cifri, ne po samom broju: 21 traži isti oblik kao 1,
 *   a 22 kao 2. Izuzetak su 11–14, koji uvek idu u treći oblik — „11 adresa",
 *   ne „11 adresa" po cifri 1.
 *
 * @param jedna oblik za 1, 21, 31… („adresa")
 * @param dve oblik za 2–4, 22–24… („adrese")
 * @param mnogo oblik za 5–20, 25–30… („adresa")
 */
export function mnozina(n: number, jedna: string, dve: string, mnogo: string): string {
  const zadnjeDve = Math.abs(n) % 100;

  if (zadnjeDve >= 11 && zadnjeDve <= 14) {
    return mnogo;
  }

  const zadnja = Math.abs(n) % 10;

  if (zadnja === 1) {
    return jedna;
  }

  if (zadnja >= 2 && zadnja <= 4) {
    return dve;
  }

  return mnogo;
}

/** „3 adrese" — brojka i reč zajedno, jer se uvek idu u paru. */
export function brojUzRec(n: number, jedna: string, dve: string, mnogo: string): string {
  return `${n} ${mnozina(n, jedna, dve, mnogo)}`;
}

/** Dan ili dana, za redove koji čekaju. */
export function dana(n: number): string {
  return mnozina(n, 'dan', 'dana', 'dana');
}
